module.exports = __webpack_public_path__ + "static/Group5995@2x-dad9d6ae7ec6f1ceefb98135bd9ed4e2.png";